import asyncComponentLoader from '@/shared/lib/loader';

import { ROUTES } from '../paths';
import { PageRoute } from '../types';

export const servicesSharedRoutes: PageRoute[] = [
  {
    component: asyncComponentLoader(() => import('@/features/services/pages/ServiceFormPage')),
    path: `${ROUTES.AUTHORIZED.SERVICE_FORM}/:id?`,
    title: 'Service Form',
  },
  {
    component: asyncComponentLoader(() => import('@/features/services/pages/ServiceRemovePage')),
    path: `${ROUTES.AUTHORIZED.DELETE_SERVICE}/:id`,
    title: 'Delete Service',
  },
];
